export enum ClientType {
  OPERATOR = 'Operator',
  AUTHORITY = 'Authority',
  COMPANY = 'Company',
}
